import React, { Component, Fragment } from 'react';
import ResponsiveTable from 'Components/ResponsiveTable';
import TripTableHeader from 'Components/TripTableHeader/index';
import AddTrip from 'Components/SecondaryTripTable/addTrip';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as MinusIcon } from 'Icons/minus.svg';
import { ReactComponent as CopyIcon } from 'Icons/copy.svg';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import { ReactComponent as EditIcon } from 'Icons/edit.svg';
import AddOtherCost from "Components/SecondaryTripTable/AddOtherCost";
import Cx from 'classnames';
import { isAdaniWilmar } from 'Utils/';
import { EMAMI } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
import { isSapDPL } from 'Utils/index';

class SecondaryTripTable extends Component {
   constructor(props) {
      super(props);
      this.state = {
         slabTripIds: [],
         editTripId: '',
      }
   }

   slabDetails = (e, tripData) => {
      e.stopPropagation();
      this.setState({
         slabTripIds: [tripData.id],
         trip: tripData,
      })
      this.CancelEdit();
   }

   closeSlabDetails = (e, tripData) => {
      e.stopPropagation();
      this.setState({
         slabTripIds: []
      })
   }

   onEditTrip = (e, tripData) => {
      e.stopPropagation();
      this.setState({ editTripId: tripData.id, slabTripIds: [] });
      this.props.showAddTrip(Object.assign({}, tripData));
   }

   CancelEdit = () => {
      this.setState({ editTripId: '' });
      this.props.hideAddTrip();
   }

   addTrip = (trip, isCopy) => {
      const { rfqServiceType, rfqType, addTrip } = this.props;
      const data = Object.assign({}, trip.getApiData(rfqType, rfqServiceType));
      data.stops = [{
         from: !isCopy && data.stops.length && data.stops[0] || {},
         to: !isCopy && data.stops.length && data.stops[1] || {},
         tat: trip.secTat,
         slabs: (trip.slabs || []).map(slab => {
            return slab.getApiData();
         }),
         multi_mode_heading_charges: trip.multiModeHeadingCharges,
         secondary_name: trip.secName,
         secondary_upto_km: (trip.secUptoKM===undefined)?0:trip.secUptoKM,
         secondary_km_run: +trip.secKmRun,
         working_hours_per_day: +trip.workingHoursPerDay,
         working_days_per_month: +trip.workingDaysPerMonth,
         secondary_qbr: (isCopy || data.trip_id) ? +trip.originalQbr : +trip.secondaryQbr,
         number_of_vehicle: +trip.numberOfVehicle
      }]

      if(isSapDPL()){
         data.fixed_price=trip.fixed_price
         data.fixed_price_uom_id=trip.fixed_price_uom_id
         data.variable_cost=trip.variable_cost
         data.variable_cost_uom_id=trip.variable_cost_uom_id
      }
      
      //   data.trip_id = trip.id;
      if (isCopy) {
         data.trip_id = '';
      }
      addTrip(data, '', isCopy);
      if (trip.id && !isCopy) {
         this.CancelEdit();
      }
   }

   copyTrip = (e, trip) => {
      e.stopPropagation();
      this.addTrip(trip, true)
   }

   deleteTrip = (e, trip) => {
      e.stopPropagation();
      this.props.deleteAddedTrip(trip);
   }

   render() {
      const {
         trips,
         autoSuggestLocations,
         addingTrip,
         vehicleTypes,
         vehicleBodyTypes,
         addTrip,
         rfqServiceType,
         rfqType,
         hideAddTrip,
         secondaryContractType,
         secondaryToLocations,
         secondaryUpToKmList,
         EditTrip,
         branchesList,
         selectedNavBranch,
         plantLocationList,
         depotLocationList,
         clusterDetails,
         businessVolumes,
         pricingBasis
      } = this.props;
      let isBranchName=false;
      let isFromBranchName = false;
      {(trips || []).map((trip, index) => {
        if(trip && trip.branchTypeName){
         isBranchName=true;
        }
      })};
      {(trips || []).map((trip, index) => {
         if(trip && trip.branchFromTypeName){
            isFromBranchName=true;
         }
       })};
      const { slabTripIds, editTripId } = this.state;
      const isEmami = EMAMI.includes(getUser().companyId);

      return (
         <Fragment>
            {addingTrip && !EditTrip &&
               <AddTrip
                  autoSuggestLocations={autoSuggestLocations}
                  vehicleTypes={vehicleTypes}
                  vehicleBodyTypes={vehicleBodyTypes}
                  secondaryToLocations={secondaryToLocations}
                  secondaryUpToKmList={secondaryUpToKmList}
                  addTrip={this.addTrip}
                  rfqServiceType={rfqServiceType}
                  rfqType={rfqType}
                  hideAddTrip={hideAddTrip}
                  secondaryContractType={secondaryContractType}
                  branchesList ={branchesList}
                  selectedNavBranch={selectedNavBranch}
                  plantLocationList={plantLocationList}
                  depotLocationList={depotLocationList}
                  clusterDetails={clusterDetails}
                  businessVolumes={businessVolumes}
                  pricingBasis={pricingBasis}
               />
            }
            <ResponsiveTable >
               {
                  <Fragment>
                     {trips && trips.length > 0 && <div className="flex flex-middle mb-20 ">
                        <div className="fBold fs-16 header-dark-color wt-25 pl-5">Trip</div>
                        {isEmami && <div className="fBold fs-16 header-dark-color wt-100 pl-15">Cluster</div>}
                        <div className="fBold fs-16 header-dark-color wt-100 pl-15">From</div>
                        {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className="fBold fs-16 header-dark-color wt-100 pl-15">To</div>}
                        
                        {isFromBranchName && <div className="fBold fs-16 header-dark-color wt-100 pl-15">From Branch Name</div>}
                       {isBranchName && <div className="fBold fs-16 header-dark-color wt-100 pl-15">To Branch Name</div>}
                      
                       
                        <div className="fBold fs-16 header-dark-color wt-150  pl-15">Description</div>
                        {!isAdaniWilmar() && <div className="fBold fs-16 header-dark-color wt-80  pl-15">Minimum Km</div>}
                        {(isAdaniWilmar() ? secondaryContractType !== 2 : true) && <div className={Cx("fBold fs-16 header-dark-color wt-150 pl-15", {
                           'wt-150': secondaryContractType === 2,
                           'wt-200': secondaryContractType !== 2
                        })}>Vehicle Type</div>}
                        {!isAdaniWilmar() && <>
                           <div className="fBold fs-16 header-dark-color wt-100 pl-15">Body Type</div>
                           <div className="fBold fs-16 header-dark-color wt-80 pl-15">No. Of Vehicles</div>
                           <div className={Cx("fBold fs-16 header-dark-color pl-15", {
                              'wt-50': secondaryContractType === 2,
                              'wt-80': secondaryContractType !== 2
                           })}>KM Run~</div>
                        </>}
                        {secondaryContractType === 2 && !isAdaniWilmar() && 
                           <Fragment>
                              <div className="fBold fs-16 header-dark-color wt-80 pl-15">Working Hrs/Day</div>
                              <div className="fBold fs-16 header-dark-color wt-80 pl-15">Working Hrs/Month</div>
                           </Fragment>
                        }
                        {(isAdaniWilmar() && secondaryContractType !== 2 ) &&
                        <>
                           <div className="fBold fs-16 header-dark-color wt-100 pl-15">Carring Capacity</div>
                           <div className="fBold fs-16 header-dark-color wt-100 pl-15">Fixed km /Month</div>
                           <div className="fBold fs-16 header-dark-color wt-100 pl-15">LPP</div>
                           <div className="fBold fs-16 header-dark-color wt-100 pl-15">MR</div>
                           <div className="fBold fs-16 header-dark-color wt-100 pl-15">Extra cost / km</div>
                        </>}
                        {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className="fBold fs-16 header-dark-color wt-80 pl-15">TAT</div>}
                        {(isAdaniWilmar() && secondaryContractType === 2) && <div className="fBold fs-16 header-dark-color wt-80 pl-15">Route Code</div>}
                        {(isAdaniWilmar() ? secondaryContractType !== 2 : true) && <div className="fBold fs-16 header-dark-color wt-80 pl-15">QBR</div>}
                        <div className="fBold fs-16 header-dark-color wt-80 pl-15">Actions</div>
                     </div>}
                     {(trips || []).map((trip, index) => {
                        return (
                           <Fragment>
                              <div className="flex flex-middle mb-10 pv-10 ph-10 border-top-light" key={`sec_${index}`} onClick={(e) => this.onEditTrip(e, trip)}>
                                 <div className="fs-14 table-text-color wt-25 pl-5">{index + 1}</div>
                                 {isEmami && <div className="fs-14 table-text-color wt-100 pl-15">{trip.clusterCode}</div>}
                                 <div className="truncate-long-text fs-14 table-text-color wt-100 pl-15" title={trip.from}>{trip.from}</div>
                                 {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className="fs-14 table-text-color wt-100 pl-15">{trip.to}</div>}
                                 {trip && trip.branchFromTypeName && <div className="truncate-long-text fs-14 table-text-color wt-100 pl-15" title={trip.branchFromTypeName}>{trip.branchFromTypeName}</div>}
                               {trip && trip.branchTypeName && <div className="truncate-long-text fs-14 table-text-color wt-100 pl-15" title={trip.branchTypeName}>{trip.branchTypeName}</div>}
                               {trip && !trip.branchTypeName && isBranchName &&<div className="fs-14 table-text-color wt-100 pl-15"></div>}
                               {trip && !trip.branchFromTypeName && isFromBranchName &&<div className="fs-14 table-text-color wt-100 pl-15"></div>}
                                 <div className="fs-14 table-text-color wt-150 pl-15">
                                    {trip.secName}
                                    {slabTripIds.indexOf(trip.id) === -1 && <PlusIcon className="wt-15 ht-15 bg-theme ml-5 br-20 curP" onClick={(e) => this.slabDetails(e, trip)} />
                                       || <MinusIcon className="wt-15 ht-15 ml-5 br-20 curP" onClick={(e) => this.closeSlabDetails(e, trip)} />}
                                 </div>
                                 {!isAdaniWilmar() && <div className="fs-14 table-text-color wt-80 pl-15">{trip.secUptoKM}</div>}
                                 {(isAdaniWilmar() ? secondaryContractType !== 2 : true) && <div className={Cx("fs-14 table-text-color pl-15", {
                                    'wt-150': secondaryContractType === 2,
                                    'wt-200': secondaryContractType !== 2
                                 })}>{trip.vehicleTypeName}</div>}
                                 {!isAdaniWilmar() && <>
                                    <div className="fs-14 table-text-color wt-100 pl-15">{trip.vehicleBodyTypeName}</div>
                                    <div className="fs-14 table-text-color wt-80 pl-15">{trip.numberOfVehicle>0 ?trip.numberOfVehicle:""}</div>
                                    <div className={Cx("fs-14 table-text-color pl-15", {
                                       'wt-50': secondaryContractType === 2,
                                       'wt-80': secondaryContractType !== 2
                                    })}>{trip.secKmRun}</div>
                                 </>}
                                 {secondaryContractType === 2 && !isAdaniWilmar() && 
                                    <Fragment>
                                       <div className="fs-14 header-dark-color wt-80 pl-15">{trip.workingHoursPerDay}</div>
                                       <div className="fs-14 header-dark-color wt-80 pl-15">{trip.workingDaysPerMonth}</div>
                                    </Fragment>
                                 }
                                 {(isAdaniWilmar() && secondaryContractType !== 2 ) &&
                                 <>
                                    <div className="fs-14 table-text-color wt-100 pl-15">{trip.carryingCapacity}</div>
                                    <div className="fs-14 table-text-color wt-100 pl-15">{trip.fixedKmPerMonth}</div>
                                    <div className="fs-14 table-text-color wt-100 pl-15">{trip.lpp}</div>
                                    <div className="fs-14 table-text-color wt-100 pl-15">{trip.marketRate}</div>
                                    <div className="fs-14 table-text-color wt-100 pl-15">{trip.extraCostPerKm}</div>
                                 </>}
                                 {(isAdaniWilmar() ? secondaryContractType === 2 : true) && <div className="fs-14 table-text-color wt-80 pl-15">{trip.secTat.value} {trip.secTat.name}</div>}
                                 {(isAdaniWilmar() && secondaryContractType === 2) && <div className={Cx("fs-14 table-text-color wt-80 pl-15", {'error-color blinking fBold': !trip.routeCode})}>{trip.routeCode || 'Route Code Missing'}</div>}
                                {(isAdaniWilmar() ? secondaryContractType !== 2 : true) && 
                                <>{trip.secondaryQbr>0 ?<div className="fs-14 table-text-color wt-80 pl-15">{trip.secondaryQbr}</div>:<div className="fs-14 table-text-color wt-80 pl-15">{(isAdaniWilmar() && secondaryContractType !== 2) ? trip.originalQbr : ''}</div>}</>}
                                 <div className="fs-14 table-text-color wt-80 pl-15">
                                    {!isAdaniWilmar() && <CopyIcon className="wt-15 ht-15 ml-5 curP" onClick={(e) => this.copyTrip(e, trip)}/>}
                                    <EditIcon className="wt-15 ht-15 ml-5 curP fBold" onClick={(e) => this.onEditTrip(e, trip)} />
                                    <DeleteIcon className="wt-15 ht-15 ml-5 curP" onClick={(e) => this.deleteTrip(e, trip)} />
                                 </div>
                              </div>
                              {slabTripIds.indexOf(trip.id) > -1 && <AddOtherCost trip={trip} tableDetails={true} onChange={this.onChange} onChangeHC={this.onChange} secondaryContractType={secondaryContractType}/>}
                              {editTripId === trip.id && <AddTrip
                                 vehicleTypes={vehicleTypes}
                                 vehicleBodyTypes={vehicleBodyTypes}
                                 secondaryToLocations={secondaryToLocations}
                                 addTrip={this.addTrip}
                                 rfqServiceType={rfqServiceType}
                                 rfqType={rfqType}
                                 hideAddTrip={this.CancelEdit}
                                 secondaryContractType={secondaryContractType}
                                 secondaryUpToKmList={secondaryUpToKmList}
                                 trip={trip}
                                 branchesList={branchesList}
                                 selectedNavBranch={selectedNavBranch}
                                 plantLocationList={plantLocationList}
                                 depotLocationList={depotLocationList}
                                 clusterDetails={clusterDetails}
                              />}
                           </Fragment>
                        )
                     })}
							{trips && trips.length === 0 && <div className="fBold fs-14 caption-color pl-5 mt-10 mb-20 tCenter">No Trip Has Been Added</div>}
                  </Fragment>
                  //  )
                  //   })
               }
            </ResponsiveTable>
         </Fragment>
      )
   }
}

export default SecondaryTripTable;
